(function () {
  'use strict';

  var startAt = Date.parse('2026-07-20T00:00:00+02:00');
  var endAt = Date.parse('2026-07-28T00:00:00+02:00');
  var now = Date.now();

  if (now < startAt || now >= endAt) return;

  function addCelebrationBar() {
    var inner = document.querySelector('.km-trust-bar-inner');
    if (!inner || inner.querySelector('.km-champion-bar-label')) return;

    var label = document.createElement('div');
    label.className = 'km-champion-bar-label';
    label.setAttribute('role', 'status');
    label.setAttribute('aria-label', 'Espa\u00f1a, campeona del mundo. Dos estrellas: 2010 y 2026.');
    label.innerHTML =
      '<span>Espa\u00f1a, campeona del mundo</span>' +
      '<span class="km-champion-bar-stars" aria-hidden="true">&#9733;&#9733;</span>' +
      '<span>2010 - 2026</span>';
    inner.appendChild(label);
  }

  function addHeroLockup() {
    var content = document.querySelector('.ksz-content');
    if (!content || content.querySelector('.km-champion-lockup')) return;

    var lockup = document.createElement('div');
    lockup.className = 'km-champion-lockup';
    lockup.setAttribute('aria-label', 'Espa\u00f1a, campeona del mundo en 2010 y 2026');
    lockup.innerHTML =
      '<span class="km-champion-lockup-stars" aria-hidden="true">&#9733;&#9733;</span>' +
      '<span class="km-champion-lockup-copy">' +
        '<strong class="km-champion-lockup-title">Espa\u00f1a, campeona del mundo</strong>' +
        '<span class="km-champion-lockup-years">Dos estrellas &middot; 2010 - 2026</span>' +
      '</span>';
    content.insertBefore(lockup, content.firstChild);
  }

  function addConfetti() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var storageKey = 'km-spain-champions-2026-confetti-v1';
    try {
      if (window.localStorage.getItem(storageKey)) return;
      window.localStorage.setItem(storageKey, 'seen');
    } catch (error) {
      // Storage can be unavailable in private browsing; the finite animation is still safe.
    }

    var layer = document.createElement('div');
    var colors = ['#aa151b', '#f1bf00', '#ffffff', '#7c3aed'];
    layer.className = 'km-champion-confetti';
    layer.setAttribute('aria-hidden', 'true');

    for (var index = 0; index < 32; index += 1) {
      var piece = document.createElement('i');
      var width = 5 + Math.round(Math.random() * 5);
      piece.className = 'km-champion-confetti-piece';
      piece.style.setProperty('--km-x', (Math.random() * 100).toFixed(2) + '%');
      piece.style.setProperty('--km-w', width + 'px');
      piece.style.setProperty('--km-h', Math.round(width * 1.7) + 'px');
      piece.style.setProperty('--km-color', colors[index % colors.length]);
      piece.style.setProperty('--km-delay', Math.round(Math.random() * 650) + 'ms');
      piece.style.setProperty('--km-duration', (2500 + Math.round(Math.random() * 1200)) + 'ms');
      piece.style.setProperty('--km-drift', (-60 + Math.round(Math.random() * 120)) + 'px');
      piece.style.setProperty('--km-rotation', (360 + Math.round(Math.random() * 540)) + 'deg');
      layer.appendChild(piece);
    }

    document.body.appendChild(layer);
    window.setTimeout(function () {
      layer.remove();
    }, 4600);
  }

  function init() {
    document.body.classList.add('km-spain-champions');
    addCelebrationBar();
    addHeroLockup();
    addConfetti();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
